<template>
  <div>
    <!-- <CongratulationsModal
      v-if="congratulationsModal"
      :deviceTag="newdeviceTag"
      :show="congratulationsModal"
      v-on:closeCongratulationsModal="congratulationsModal = false"
    /> -->
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="adddevice"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("add-device") }}
            </h5>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="doSwap">
              <div class="form-group">
                <label>{{ variableText.label }}</label>
                <input
                  type="text"
                  name="imei"
                  v-model="imei"
                  class="form-control"
                  required
                />
                <p class="mb-0 mt-2 gray4">
                  <b>{{ $t("tip") }}</b
                  >: {{ variableText.tips }}
                </p>
                <img
                  class="mt-3 img"
                  width="100%"
                  height="180px"
                  :src="variableText.img"
                />
              </div>

              <div
                class="form-group mb-0"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ $t("add-dev") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import coldBox from "../../assets/images/Group 1315.png";
import mote from "../../assets/images/Mote.png";
import novatrack from "../../assets/images/Group 1316.png";
import lora from "../../assets/images/lora 2.png";
// import CongratulationsModal from "./CongratulationsModal";

export default {
  name: "SwapDevice",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      imei: "",
      // newdeviceTag: "",
      mssg: "",
      Errormssg: "",
      // congratulationsModal: true,
      deviceType: "mote",
    };
  },
  components: {
    Loading,
    // CongratulationsModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["singledevice"]),
    variableText() {
      let variableText = {
        tips: "",
        label: "",
        img: "",
      };
      if (this.deviceType === "mote") {
        variableText.tips = this.$t("mote-err");
        variableText.label = "New IMEI";
        // variableText.img = '../../assets/images/imei-two.jpg';
        variableText.img = mote;
      }
      if (this.deviceType === "coldBox") {
        variableText.tips = this.$t("mote-err");
        variableText.label = "IMEI";
        variableText.img = coldBox;
      }
      if (this.deviceType === "novatrack") {
        variableText.tips = this.$t("nov-err");
        variableText.label = "IMEI/DevEui";
        variableText.img = novatrack;
      }
      if (this.deviceType === "lora" || this.deviceType === "glog5") {
        variableText.tips = this.$t("lora-err");
        variableText.label = "IMEI/ID";
        variableText.img = lora;
      }

      return variableText;
    },
  },
  methods: {
    ...mapActions(["swapDevice"]),
    onCancel() {
      this.imei = "";
      this.Errormssg = "";
      this.$emit("closeSwap");
    },
    doSwap() {
      this.isLoading = true;
      this.Errormssg = "";
      const newdevice = {
        imei: this.imei,
        imei_id: this.$route.params.device_id,
      };
      this.swapDevice(newdevice)
        .then((res) => {
          this.isLoading = false;
          this.$emit("showMsg");
          this.mssg = res.data.payload.message;
          // setTimeout(() => {
          //   this.isLoading = true;
          // }, 1000);
          setTimeout(() => {
            this.isLoading = false;
            window.location.reload();
            this.onCancel();
          }, 2000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
.img {
  width: auto;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}
</style>

<i18n>
{
	"en": {
		"add-dev": "Swap Device",
		"add-device": "Device Swap",
		"cancel": "Cancel",
		"lora-err": "The ID is the 8 digit number found at the bottom back of the device.",
		"mote-err": "The IMEI is the 15 digit number found at the bottom back of the device",
		"nov-err": "The DevEui is the 16 digit number found at the bottom back of the device.",
		"sel-dev-type": "Select Device Type",
		"tip": "Tip"
	},
	"fr": {
		"add-dev": "Permuter l'appareil",
		"add-device": "Échange d'appareil",
		"cancel": "annuler",
		"lora-err": "L'ID est le numéro à 8 chiffres situé en bas à l'arrière de l'appareil.",
		"mote-err": "L'IMEI est le numéro à 15 chiffres qui se trouve en bas à l'arrière de l'appareil",
		"nov-err": "Le DevEui est le numéro à 16 chiffres situé en bas à l'arrière de l'appareil.",
		"sel-dev-type": "Sélectionnez le type d'appareil",
		"tip": "Pointe"
	},
	"sw": {
		"add-dev": "Badilisha Kifaa",
		"add-device": "Kubadilisha Kifaa",
		"cancel": "Ghairi",
		"lora-err": "Kitambulisho ni nambari ya tarakimu 8 inayopatikana sehemu ya chini ya nyuma ya kifaa.",
		"mote-err": "IMEI ni nambari ya tarakimu 15 inayopatikana sehemu ya chini ya nyuma ya kifaa",
		"nov-err": "DevEui ni nambari ya tarakimu 16 inayopatikana sehemu ya chini ya nyuma ya kifaa.",
		"sel-dev-type": "Chagua Aina ya Kifaa",
		"tip": "Kidokezo"
	}
}
</i18n>
